<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:900px">
        <div class="edit">
              <table class="layui-table layui-form"  style="margin-left: 15px;">
                  <thead>
                    <tr class="table-tr-td ">
                      <th class="add-www">账户名称</th>
                      <th v-for="item in currency" :key="item.name" class="add-www  naa"  >{{ item.name }}</th>
                      <th class="add-www">合计RMB</th>
                    </tr>
                  </thead>
                  <tbody id="tab-list">
                    <tr v-for="row in datalist" :key="row.id"    class="maxs"  >
                        <th  v-for="items in row"  :key="items.id"  :style="{ color: (items instanceof Object ? items.amount : items) == 0 ? '#fff' : (items instanceof Object ? items.amount : items) < 0 ? 'red' : '#6b6565' }" >
                            {{ items instanceof Object ? items.amount : items }}
                        </th>
                    </tr>
                  </tbody>
                </table>
        </div>
      </div>
    </el-main>
  </div>
</template>


<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPBankApi } from "@/api/bank/Account_details.js"

export default {
  components: {

    GlobalHeader
  },
  data() {

    return {
      activeIndex: "8-1",
      datalist: [],
      currency: [],
    };
  },
  created() {
    ERPBankApi().then((res) => {
        this.currency = res.data.currency,
        this.datalist = res.data.dataList

    });

  },
  mounted() {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}
.edit{
    .layui-table{
      min-width: 900px;
      height: 600px;
      padding: 10px;
      font-size: 12px;
      border: 1px solid;
    }

    .add-www{
      height: 40px;
    }
    table {
      border-collapse: collapse;
    }
    th{
      width: 60px;
      height:36px;
      border: 1px solid #e6e6e6;
      font-size: 13px;
      text-align: left;
      text-indent: 1em;
      font-weight: 600;
      color: #333;
    }
    .add-www{
      width:105px;
    }
}
/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}

.maxs th{
  color: #000 ;
  font-weight: 400 !important;
}
.maxs th:nth-child(1){
  font-weight: 600 !important;
  text-align: left;
  text-indent: 1em;
  width:200px;
}
#tab-list .maxs th:last-child {
  font-weight: 600 !important;
}
#tab-list .maxs:last-of-type th {
  font-weight: 600 !important;
}
</style>



// WEBPACK FOOTER //
// src/src/Bank_management/Account_details/index.vue